import { useState } from 'react';
import { Select, SelectProps, Spin } from '@arco-design/web-react';
import { useSelect } from '../api';

export const SelectUser = ({ value, onChange, mode = undefined }: SelectProps) => {
  const [mobile, setMobile] = useState('');
  const { data, isFetching } = useSelect({
    params: {
      mobile,
      pageIndex: 1,
      pageSize: 10,
      id: value as number | undefined,
    },
    config: {
      enabled: mobile.length > 0 || !!value,
    },
  });
  return (
    <Select
      showSearch
      mode={mode}
      allowClear
      options={data?.data.items.map((v) => ({
        label: `${v.real_name ? v.real_name : v.name}-${v.mobile}`,
        value: v.id,
      }))}
      loading={isFetching}
      placeholder="通过手机号搜索用户"
      filterOption={false}
      onChange={onChange}
      value={value}
      notFoundContent={
        isFetching ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Spin style={{ margin: 12 }} />
          </div>
        ) : null
      }
      onSearch={(value) => {
        setMobile(value);
      }}
    />
  );
};
